import type { Routes } from '@angular/router';
import { secureRoute } from './core/utils/transformers';
import { ProcedureSetDetailsComponent } from './features/procedures/pages/procedure-set-details/procedure-set-details';
import { ProcedureSetEditComponent } from './features/procedures/pages/procedure-set-edit/procedure-set-edit';
import { ProcedureSetsViewComponent } from './features/procedures/pages/procedure-sets-view/procedure-sets-view';

export const procedureSetsRoutes: Routes = [
  secureRoute({
    path: 'procedure-sets',
    component: ProcedureSetsViewComponent,
    data: {
      roles: ['mhs.scmmanager.user'],
      breadcrumbs: [
        {
          id: 0,
          label: 'zestawy',
          isCurrent: true,
          url: '/procedure-sets',
        },
      ],
    },
  }),
  secureRoute({
    path: 'procedure-sets/:id/details',
    component: ProcedureSetDetailsComponent,

    data: {
      roles: ['mhs.scmmanager.user'],
      breadcrumbs: [
        {
          id: 0,
          label: 'zestawy',
          isCurrent: false,
          url: '/procedure-sets',
        },
        {
          id: 1,
          label: 'detale',
          isCurrent: true,
          url: '/procedure-sets/:id/details',
        },
      ],
    },
  }),
  secureRoute({
    path: 'procedure-sets/:id/edit',
    component: ProcedureSetEditComponent,

    data: {
      roles: ['mhs.scmmanager.user'],
      breadcrumbs: [
        {
          id: 0,
          label: 'zestawy',
          isCurrent: false,
          url: '/procedure-sets',
        },
        {
          id: 1,
          label: 'edycja',
          isCurrent: true,
          url: '/procedure-sets/:id/edit',
        },
      ],
    },
  }),
];
